<template>
  <v-autocomplete
    :value="value"
    dense
    outlined
    hide-details
    class="rmr-input"
    :class="{ 'rmr-input--md': size === 'md', 'rmr-input--no-chips': noChips }"
    v-bind="fieldAttrs"
    v-on="listeners"
  >
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </v-autocomplete>
</template>

<script>
import { rmrChoiceFieldComputed } from "./build-rmr-choice-field-attrs";

export default {
  name: "RmrAutocomplete",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null,
    },
    noChips: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },
  computed: rmrChoiceFieldComputed,
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";
</style>
